import { Flex, Tooltip } from "@chakra-ui/react";
import { t } from "@lingui/macro";
import { OutgoingInvoiceTypeEnum } from "@src/__generated__/urql-graphql";
import { ButtonLink } from "@src/components/ui-kit";
import { Icon } from "@src/components/ui-kit/Icon";
import { assert } from "@src/utils/types";
import { useInvoiceDetailStore } from "../store";

export const InvoiceEditButton = () => {
  const store = useInvoiceDetailStore();

  assert(store.invoice);

  const canBeEdited = (() => {
    if (store.invoice.isProformaPayment) return false;
    if (store.isProforma && store.invoice.paid_at) return false;
    if (store.hasModelLock) return false;
    return true;
  })();

  return (
    <Tooltip
      isDisabled={canBeEdited}
      label={t`Paid proforma invoice cannot be edited`}
    >
      <Flex flex="1">
        <ButtonLink
          flex="1 1 100%"
          href={{
            pathname: store.isOutgoing
              ? `/invoices/outgoing-invoices/${canBeEdited ? "edit" : "detail"}`
              : `/invoices/proforma-invoices/${canBeEdited ? "edit" : "detail"}`,
            query: {
              id: store.invoice.id,
            },
          }}
          isDisabled={!canBeEdited}
          leftIcon={<Icon name="edit-02" />}
        >
          {store.invoice.type === OutgoingInvoiceTypeEnum.CreditNote
            ? t`Edit credit note`
            : t`Edit invoice`}
        </ButtonLink>
      </Flex>
    </Tooltip>
  );
};
